import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from './modal.service';

import {
  SettingsService,
  SidebarService,
  HeaderService,
  SharedService,
  UsuarioService,
  LoginGuardGuard,
  AdminGuard,
  VerificaTokenGuard,
  DocumentoclienteService
 } from './service.index';
import { EntradasService } from '../modulos/entradas/services/entradas.service';
import { ProductosService } from '../modulos/seguridad/services/productos/productos.service';
import { UnidadesMedidaService } from '../modulos/seguridad/services/productos/unidades-medida.service';
import { ParametrosServiceService } from '../modulos/services/parametros/parametrosService.service';
import { IngresoService } from '../modulos/entradas/services/ingreso.service';
import { EmpresaService } from '../modulos/seguridad/services/empresa/empresa.service';
import { AlmacenService } from '../modulos/seguridad/services/almacen/almacen.service';
import { CuentaService } from '../modulos/services/cuentas/cuenta.service';
import { ParametrosService } from '../modulos/seguridad/services/parametros/parametros.service';
import { LoginempresaService } from './loginempresa/loginempresa.service';
import { AuditoriasunatService } from '../modulos/entradas/services/auditoriasunat.service';
import { VehiculoService } from '../modulos/seguridad/services/vehiculo/vehiculos.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    SettingsService,
    SidebarService,
    HeaderService,
    SharedService,
    UsuarioService,
    DocumentoclienteService,
    LoginempresaService,
    LoginGuardGuard,
    AdminGuard,
    VerificaTokenGuard,
    ModalService,
    EntradasService,
    ProductosService,
    UnidadesMedidaService,
    ParametrosServiceService,
    IngresoService,
    EmpresaService,
    AlmacenService,
    CuentaService,
    ParametrosService,
    AuditoriasunatService,
    VehiculoService
  ],
  declarations: []
})
export class ServiceModule { }
